import { getType } from 'typesafe-actions';

import {
  setOrders,
  setHasManualOverstockOrder,
  setOrderStatus,
  clearSelected,
  getPickToursInProgress,
  setPickToursInProgress,
  resetActivePickTourComplete,
  setPickTourWithError,
} from '../actions/orders.actions';

import { OrdersState } from './types';
import { RootAction } from '../actions/types';

const initialState: OrdersState = {
  ordersByType: {},
  pickToursByType: {},
  completedRecalls: {
    links: [],
    content: [],
    page: {
      number: 0,
      size: 0,
      totalElements: 0,
      totalPages: 0,
    },
  },
  completedEPTours: {
    content: [],
    currentPage: 0,
    totalPages: 0,
  },
  hasManualOverstockOrder: false,
  lastAttemptSuccess: false,
  lastAttemptTimeStamp: Date.now(),
  clearSelected: false,
  errorPickTour: null,
};

export default (state: OrdersState = initialState, action: RootAction): OrdersState => {
  switch (action.type) {
    case getType(setOrders): {
      return { ...state, ...action.payload };
    }
    case getType(setHasManualOverstockOrder): {
      return { ...state, ...action.payload };
    }

    case getType(setOrderStatus): {
      return { ...state, ...action.payload };
    }

    case getType(getPickToursInProgress): {
      return { ...state, pickToursByType: {} };
    }

    case getType(setPickToursInProgress): {
      return { ...state, ...action.payload };
    }

    case getType(resetActivePickTourComplete): {
      const { pickTour, pickTourIndex } = action.payload;
      const { pickTourType } = pickTour;
      return {
        ...state,
        pickToursByType: {
          ...state.pickToursByType,
          [pickTourType]: {
            ...state.pickToursByType[pickTourType],
            pickTours:
              state.pickToursByType[pickTourType]?.pickTours?.map((tour, index) =>
                index === pickTourIndex ? pickTour : tour
              ) || [],
          },
        },
      };
    }

    case getType(clearSelected): {
      return { ...state, ...{ clearSelected: action.payload } };
    }

    case getType(setPickTourWithError): {
      return { ...state, ...action.payload };
    }

    default: {
      return state;
    }
  }
};
